module.exports = __webpack_public_path__ + "img/seminar3.f0584974.jpg";